import { render, staticRenderFns } from "./Referrals.vue?vue&type=template&id=3f419ff1&scoped=true"
import script from "./Referrals.vue?vue&type=script&lang=js"
export * from "./Referrals.vue?vue&type=script&lang=js"
import style0 from "./Referrals.vue?vue&type=style&index=0&id=3f419ff1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f419ff1",
  null
  
)

export default component.exports